







































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  RedCapital,
  SelectedCountry,
  TitleTemplatePublic,
} from "@/configuration";
import Contacto from '@/views/prontoPago/Contact.vue';
import { mapState } from "vuex";
import API from "@/api";

@Component({
  metaInfo: {
    title: "RedCapital  | Plataforma de Financiamiento Digital ",
    //titleTemplate: TitleTemplatePublic,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang,
    },
  },
  computed:{
	  ...mapState(["amountFinanced"]),
  },
  data(){
	  return {
		  amounts: {
			financed: 0,
			facturas: 0,
			inversiones: 0,
			render: {
				financed: 0,
				facturas: 0,
				inversiones: 0,
			}
		},
	  }
  },
  async mounted(){
	if (this.$route.hash) {
	//@ts-ignore
	setTimeout(() => this.scrollTo(this.$route.hash), 1)
	}
	// 
	let amounts: any = await API.getAmounts();
	if (amounts.principal != null) {
		let dataHomeProntoPago = {
			amountFinanced : parseInt(amounts.financed),
			amountFacturas : parseInt(amounts.facturas),
			amountInveriones : parseFloat(amounts.inversiones)
		};
		this.$store.commit("setAmountDataHomeProntoPago", dataHomeProntoPago);
		this.$data.amounts.financed = parseInt(amounts.principal);
		this.$data.amounts.facturas = parseInt(amounts.facturas);
		this.$data.amounts.inversiones = parseFloat(amounts.inversiones);
	} else {
		this.$data.amounts.financed = this.$store.state.amountFinanced;
		this.$data.amounts.facturas = this.$store.state.amountFacturas;
		this.$data.amounts.inversiones = this.$store.state.amountInversiones;
	}
	
	
	let steps = 20;
	let timePerStep = 1;

	for (
		let i = this.$data.amounts.financed / steps, j = this.$data.amounts.facturas / steps, k = this.$data.amounts.inversiones / steps;
		i < this.$data.amounts.financed && j < this.$data.amounts.facturas && k < this.$data.amounts.inversiones;
		i += this.$data.amounts.financed / steps, j += this.$data.amounts.facturas / steps, k += this.$data.amounts.inversiones / steps 
	) {
		await new Promise((res, rej) => {
			setTimeout(() => {
				// @ts-ignore
				this.$data.amounts.render.financed = parseInt(i);
				// @ts-ignore
				this.$data.amounts.render.facturas = parseInt(j);
				// @ts-ignore
				this.$data.amounts.render.inversiones = parseInt(k);
				// @ts-ignore
				res();
			}, timePerStep);
		});
	}
	this.$data.amounts.render.financed = this.$data.amounts.financed;
	this.$data.amounts.render.facturas = this.$data.amounts.facturas;
	this.$data.amounts.render.inversiones = this.$data.amounts.inversiones;

	// @ts-ignore
	this.onResponsive();
	// @ts-ignore
	window.addEventListener("resize", this.onResponsive);
  },
  methods: {
    scrollTo: function (hashtag) {
      setTimeout(() => { location.href = hashtag }, 1)
    },
    onResponsive() {
      let w = window.innerWidth;
      if (w < 600) {
        this.$data.options.logos.perPage = 2;
      } else if (w > 600 && w < 960) {
        this.$data.options.logos.perPage = 3;
      } else if (w > 960 && w < 1264) {
        this.$data.options.logos.perPage = 4;
      } else if (w > 1264 && w < 1904) {
        this.$data.options.logos.perPage = 4;
      } else if (w > 1904) {
        this.$data.options.logos.perPage = 10;
      }
    },
	toProntoPago() {
		window.open('https://prontopago.redcapital.cl/login', '_blank');
	}
  },
  beforeRouteUpdate (to, from, next) {
    if(to.hash){
      //@ts-ignore
      setTimeout(() => this.scrollTo(this.$route.hash), 1)
    }
    next();
  },
   components: {
	  Contacto
  }
})
export default class About extends Vue {}
